import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

interface LogoContainerProps {
  size: 'small' | 'medium' | 'large';
}

export const LogoContainer = styled(Box)<LogoContainerProps>(({
  theme,
  size,
}) => {
  const getSize = () => {
    switch (size) {
      case 'small':
        return { width: '24px', height: '24px' };
      case 'large':
        return { width: '64px', height: '64px' };
      default:
        return { width: '40px', height: '40px' };
    }
  };

  return {
    ...getSize(),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    '& img': {
      objectFit: 'contain',
    },

    [theme.breakpoints.down('sm')]: {
      ...(size === 'large' && {
        width: '48px',
        height: '48px',
      }),
    },
  };
});
